import { Schema } from '../queries';
import { SchemaDisplayArray } from './schema-display-array';
import { SchemaDisplayBoolean } from './schema-display-boolean';
import { SchemaDisplayInteger } from './schema-display-integer';
import { SchemaDisplayNumber } from './schema-display-number';
import { SchemaDisplayObject } from './schema-display-object';
import { SchemaDisplayString } from './schema-display-string';

interface Props {
  schemaId: string;
  schema: Schema;
  path?: string;
}

const SchemaDisplayMap = {
  string: SchemaDisplayString,
  number: SchemaDisplayNumber,
  array: SchemaDisplayArray,
  object: SchemaDisplayObject,
  integer: SchemaDisplayInteger,
  boolean: SchemaDisplayBoolean,
};

export function SchemaDisplay({ schema, schemaId, path = '' }: Props) {
  const Component = SchemaDisplayMap[schema.type];
  return <Component schema={schema} path={path} schemaId={schemaId} />;
}
